import reduxCrud from 'redux-crud';

const vehiclesActionCreators = reduxCrud.actionCreatorsFor('vehicles', {
  key: 'id',
});
const actionTypes = reduxCrud.actionTypesFor('vehicles', { key: 'id' });

export default vehiclesActionCreators;
export { actionTypes };
